import { type ReactQuery } from 'cms-api'

export type Tier = ReactQuery.ExpertDashboardTradeTierResponse['currentTier']

// Mirrors the backend tier ladder
// (apps/theexpert-strapi/src/api/expert-dashboard/services/utils.ts)
// NOTE: `perks` copy comes from the design mock — confirm against the real
// business perk list before launch.
export const TIER_LADDER: { name: Tier; threshold: number; perks: string[] }[] =
  [
    {
      name: 'Member',
      threshold: 0,
      perks: [
        'Tax exemption',
        'Price match promise',
        'Exclusive trade pricing up to 35% off',
        'Order dashboard',
        'Invitations to digital events',
      ],
    },
    {
      name: 'Bronze',
      threshold: 2500,
      perks: [
        'Everything in Member',
        'Dedicated customer service team',
        'Access to business workshops',
        'Social media features',
      ],
    },
    {
      name: 'Silver',
      threshold: 25000,
      perks: [
        'Everything in Bronze',
        'Proactive order monitoring',
        'Dedicated sourcing specialist and account manager',
        'In-person event invites',
        'Email features',
      ],
    },
    {
      name: 'Gold',
      threshold: 50000,
      perks: [
        'Everything in Silver',
        'Editorial coverage',
        'Expert profile page',
        'Showroom curation',
      ],
    },
    {
      name: 'Platinum',
      threshold: 100000,
      perks: [
        'Everything in Gold',
        'Top Expert status (priority consideration)',
      ],
    },
  ]

export const fmtThresholdK = (n: number) => {
  if (n >= 1000) {
    const k = n / 1000
    return `$${Number.isInteger(k) ? k : k.toFixed(1)}k`
  }
  return `$${n}`
}
